var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,15L20,19C20,19.549 19.549,20 19,20C19,20 5,20 5,20C4.451,20 4,19.549 4,19C4,19 4,15 4,15C4,14.448 3.552,14 3,14C2.448,14 2,14.448 2,15L2,19C2,20.646 3.354,22 5,22L19,22C20.646,22 22,20.646 22,19L22,15C22,14.448 21.552,14 21,14C20.448,14 20,14.448 20,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,12.586L7.707,9.293C7.317,8.903 6.683,8.903 6.293,9.293C5.903,9.683 5.903,10.317 6.293,10.707L11.293,15.707C11.413,15.827 11.556,15.91 11.708,15.957L11.711,15.958C11.795,15.983 11.884,15.998 11.976,16L12,16L12.024,16C12.116,15.998 12.205,15.983 12.289,15.958L12.292,15.957C12.444,15.91 12.587,15.827 12.707,15.707L17.707,10.707C18.097,10.317 18.097,9.683 17.707,9.293C17.317,8.903 16.683,8.903 16.293,9.293L13,12.586L13,3C13,2.448 12.552,2 12,2C11.448,2 11,2.448 11,3L11,12.586Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9a79f24e.svg";
export { ForwardRef as ReactComponent };